export interface SchoolFrameworkStep {
  id?: number;
  step_key: string;
  step_order: number;
  name: Record<string, string>;
  description: string | null;
  sub_steps: string[];
  concepts: string[];
  positive_markers: string[];
  negative_markers: string[];
  sample_questions: string[];
  icf_competency_mapping: string | null;
}

export interface SchoolFramework {
  id: number;
  school_id: number;
  framework_key: string;
  name: Record<string, string>;
  framework_type: string;
  source_document_id: number | null;
  extracted_schema: Record<string, any>;
  icf_alignment_mapping: Record<string, any> | null;
  is_approved: boolean;
  is_active: boolean;
  approved_at: string | null;
  created_at: string;
  steps: SchoolFrameworkStep[];
}

export interface FrameworkListResponse {
  frameworks: SchoolFramework[];
  total_count: number;
}

/** ICF competency keys for mapping dropdown */
export const ICF_COMPETENCY_KEYS = [
  'ethics_standards',
  'coaching_mindset',
  'agreements',
  'trust_safety',
  'presence',
  'active_listening',
  'powerful_questioning',
  'direct_communication',
  'awareness',
  'designing_actions',
  'planning_goals',
  'managing_progress',
] as const;

export type IcfCompetencyKey = typeof ICF_COMPETENCY_KEYS[number];
